import React from 'react';
import { DetailList } from '../../components/DetailList';
import { useOemFormatContext } from '../../hooks/useOemFormatContext';
import { parseCerebrumxPayload } from './parseCerebrumxPayload';

/**
 * One CerebrumX tab: parses the payload, draws only the sections and blocks it
 * carries, and explains itself when there is nothing for the tab at all.
 * `build(view, ctx)` returns the row sections; `before`/`after(view, ctx)`
 * draw a visual block above/below them (null when the payload has none).
 */
export const CerebrumxTab = ({ record, build, before, after }) => {
	const ctx = useOemFormatContext(record.unitId);
	const { t } = ctx;
	const view = parseCerebrumxPayload(record.rawMessage);
	if (view === null) {
		return <p className="oem-data-modal-message">{t('oemDataModal_cerebrumx_unreadable')}</p>;
	}
	const sections = build(view, ctx).filter((s) => s.rows.length > 0);
	const top = before?.(view, ctx) ?? null;
	const bottom = after?.(view, ctx) ?? null;
	if (sections.length === 0 && top === null && bottom === null) {
		return <p className="oem-data-modal-message">{t('oemDataModal_cerebrumx_emptyTab')}</p>;
	}

	return (
		<div className="oem-tab-content">
			{top}
			{sections.map((s) => (
				<DetailList key={s.key} title={s.title} rows={s.rows} />
			))}
			{bottom}
		</div>
	);
};
